import apiClient from './api_client_requests';

export default async payload => {

    let result = await apiClient.apiMethod({
        method: 'MyEntries',
        args: {
            ...payload,
        },
    });

    // console.log('📮 Payload', payload); //? for testing
    // console.log('🎁 Result: ',result); //? for testing

    return {
        entries: result.myentries,
        collection: result.collection,
        drawings: result.drawings,
    };
};
